import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, BookOpen, Loader2 } from "lucide-react";
import api from "@/lib/api";
import GuideMarkdown from "@/components/GuideMarkdown";
import GameRates from "@/components/GameRates";

export default function HowToPlay() {
  const [guide, setGuide] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    api.get("/game/how-to-play").then(({ data }) => { if (active) setGuide(data); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, []);
  return <main className="min-h-screen bg-[#0B0E14] px-4 py-8 pb-28 text-slate-200">
    <article className="max-w-2xl mx-auto space-y-6">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-emerald-400"><ArrowLeft size={16} /> Back to app</Link>
      <header><div className="flex gap-3 items-center"><BookOpen className="text-emerald-400" /><h1 className="text-3xl font-bold text-white">How to Play</h1></div>
        <p className="text-sm text-slate-400 mt-2">Your guide to rounds, rewards and referrals.</p>
        {guide && <p className="text-xs text-slate-500 mt-2">{guide.updated_at ? `Updated ${new Date(guide.updated_at).toLocaleString()}` : "Official starter guide"} · Revision {guide.revision.slice(0, 8)}</p>}
      </header>
      <GameRates />
      {error ? <p role="alert">Unable to load instructions. Please reopen this page to retry.</p> : !guide ? <Loader2 className="animate-spin text-emerald-400" aria-label="Loading instructions" /> : <GuideMarkdown>{guide.markdown}</GuideMarkdown>}
      <Link to="/game-policy" className="block text-emerald-400 underline text-sm">Read game policy</Link>
    </article>
  </main>;
}
